
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","fill":"#282828","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0","y":"0","viewBox":"0 0 19 19","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"SVGID_1_","d":"M.7.9h18v18H.7z"}})]),_c('clipPath',{attrs:{"id":"SVGID_00000123398890550952089820000006067197795489244305_"}},[_c('use',{attrs:{"xlink:href":"#SVGID_1_","overflow":"visible"}})]),_c('g',{attrs:{"clip-path":"url(#SVGID_00000123398890550952089820000006067197795489244305_)"}},[_c('path',{attrs:{"d":"M4.5 10.7c-.4-.4-.4-1.1 0-1.6.2-.2.5-.3.8-.3H14c.6 0 1.1.5 1.1 1.1 0 .6-.5 1.1-1.1 1.1H5.3c-.3 0-.6-.1-.8-.3z"}}),_c('path',{attrs:{"d":"M8.9 15.2c-.2-.2-.3-.5-.3-.8v-9c0-.6.5-1.1 1.1-1.1.6 0 1.1.5 1.1 1.1v9c0 .6-.5 1.1-1.1 1.1-.3 0-.6-.1-.8-.3zM13.7 18.9h-1.2c-.4 0-.8-.4-.8-.8s.4-.8.8-.8h1.2c.9 0 1.7-.3 2.4-1 .6-.6 1-1.5 1-2.4V5.8c0-.9-.3-1.7-1-2.4-.6-.6-1.5-1-2.4-1h-1.2c-.4 0-.8-.4-.8-.8s.4-.8.8-.8h1.2c2.7 0 4.9 2.2 4.9 4.9v8.1c.1 2.9-2.1 5.1-4.9 5.1zM6.8 18.9H5.6C2.9 18.9.7 16.7.7 14V5.8C.7 3.1 2.9.9 5.6.9h1.2c.4 0 .8.4.8.8s-.4.8-.8.8H5.6c-.9 0-1.7.3-2.4 1-.6.6-1 1.5-1 2.4V14c0 .9.3 1.7 1 2.4.6.6 1.5 1 2.4 1h1.2c.4 0 .8.4.8.8 0 .3-.4.7-.8.7z"}})])])
          )
        }
      }
    